module.exports = __webpack_public_path__ + "img/instagramicon.b7c2ad30.svg";